import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const store = new Vuex.Store({
  state() {
    return {
      currentSelect: "1", //首页导航
      xwzxSelect: "1", //信息中心
      dqhdSelect: "1", //党群工作
      zxywSelect: "1", //中心业务
      jggkSelect: "1", //机构概况
      lxwmSelect: "1", //联系我们
    };
  },
  mutations: {
    setCurrentNavBarSelect(state, index) {
      state.currentSelect = index;
    },
    setXwzxNavBarSelect(state, index) {
      state.xwzxSelect = index;
    },
    setDqhdNavBarSelect(state, index) {
      state.dqhdSelect = index;
    },
    setZxywNavBarSelect(state, index) {
      state.zxywSelect = index;
    },
    setJggkNavBarSelect(state, index) {
      state.jggkSelect = index;
    },
    setLxwmNavBarSelect(state, index) {
      state.lxwmSelect = index;
    },
  },
});

export default store;
